import { TFunction } from "i18next";
import * as Yup from "yup";

export const getCampaingModalMotiveDeleteSchema = (t: TFunction) => {

    return Yup.object().shape({
        motiveDelete: Yup.string()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm")),
    });
};


export const getCampaignFormSchema = (t: TFunction) => {

    return Yup.object().shape({
        name: Yup.string()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm")),
    });
};